<template>
  <div class="container" style="height: 100%">
    <div class="top">
      <div class="back_box">
        <!-- <img src="@/assets/images/icons/icon_back.png" alt="" /> -->
        <el-button
          class="back-btn"
          type="text"
          icon="el-icon-arrow-left"
          @click="$router.go(-1)"
          >返回</el-button
        >
      </div>
      <div class="info">
        <p class="title">{{ info.name }}</p>
        <p style="margin-top: 5px">
          <span class="time">{{
            formatDate(info.startTime, "MM-DD HH:mm")
          }}</span>
          <span class="shu">|</span>
          <span>选中：{{ list.length }}人</span>
          <span class="shu">|</span>
          <span class="surplus" v-show="info.autoStop && info.status != 'STOP'"
            >剩余<i class="el-icon-time"></i>{{ surplus }}</span
          >
          <span class="end" v-show="info.status == 'STOP'">已结束</span>
        </p>
        <div class="right_btns">
          <el-button type="text">导出数据</el-button>
          <el-button
            type="text"
            v-show="info.status != 'STOP'"
            @click="handleStop"
            >结束活动</el-button
          >
        </div>
      </div>
    </div>
    <div class="main">
      <div class="btn" @click="handleSelect" v-if="info.status == 'STARTED'">
        <i class="el-icon-circle-plus-outline"></i>
        <p>开始选人</p>
      </div>
      <p class="end_tips" v-else>选人已结束</p>
      <div class="student" v-for="item in list" :key="item.userId">
        <el-image class="avatar" :src="item.avatar" fit="cover"></el-image>
        <p class="name">{{ item.nickName }}</p>
        <div class="mask">
          <i class="el-icon-delete" @click="handleDel(item.pickId)"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixinsData from "../mixins/detail";
import { pickList, pick, delPick } from "@/api/assistantMode/activity/pick";
import { formatDate } from "@/utils/index";
export default {
  name: "pick",
  mixins: [mixinsData],
  data() {
    return {
      formatDate,
      info: {},
      surplus: "",
      list: [],
    };
  },
  methods: {
    // 选中列表
    getList() {
      let activityId = this.$route.query.activityId;
      pickList({ activityId }).then((res) => {
        if (res.code == 0) {
          this.list = res.data;
        } else {
          console.log(res.msg);
        }
      });
    },
    // 选人
    handleSelect() {
      this.$loading.show();
      pick(this.$route.query.activityId).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          if (res.data) this.list.push(res.data);
          else {
            this.$message.warning("已选择所有学生");
            this.getInfo();
          }
        } else {
          console.log(res.msg);
        }
      });
    },
    // 删除选人
    handleDel(pickId) {
      this.$confirm(`确定要删除吗？`, {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          delPick(pickId).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.$message.success("删除成功");
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.top {
  margin-top: 30px;
  margin-bottom: 20px;
  width: 100%;
  text-align: left;
  .back_box {
    display: inline-block;
    width: calc(100% - 1126px);
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    img {
      width: 44px;
    }
    p {
      color: #969696;
      font-size: 16px;
    }
  }
  .info {
    position: relative;
    display: inline-block;
    padding: 24px 30px;
    background-color: #fff;
    width: 1126px;
    vertical-align: middle;
    .title {
      font-size: 16px;
      color: #333;
    }
    .time {
      margin-top: 5px;
      color: #999;
      font-size: 14px;
    }

    .shu {
      padding: 0 10px;
      color: #ddd;
    }
    .el-icon-time {
      margin: 0 5px;
    }
    .surplus {
      color: sandybrown;
    }
    .end {
      color: #999;
    }
    .right_btns {
      position: absolute;
      top: 50%;
      right: 30px;
      transform: translateY(-50%);
    }
  }
}
.main {
  padding: 30px;
  height: calc(100% - 30px - 20px - 93px - 30px);
  background-color: #fff;
  overflow: auto;
  &::-webkit-scrollbar {
    width: 4px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    background-color: #c8c8c8;
  }

  .btn {
    display: inline-block;
    margin: 20px;

    &:hover {
      .el-icon-circle-plus-outline,
      p {
        color: #1890ff;
      }
    }
    .el-icon-circle-plus-outline {
      color: #999;
      font-size: 130px;
      transition: all 0.3s ease;
      cursor: pointer;
    }
    p {
      font-size: 20px;
      color: #999;
      transition: all 0.3s ease;
    }
  }

  .end_tips {
    margin-top: 5px;
    padding-bottom: 5px;
    font-size: 20px;
    color: #999;
  }
  .student {
    position: relative;
    display: inline-block;
    margin: 20px;
    &:hover {
      .mask {
        opacity: 1;
      }
    }
    .avatar {
      width: 130px;
      height: 130px;
      border-radius: 50%;
    }
    .name {
      font-size: 20px;
      color: #333;
    }
    .mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 130px;
      height: 130px;
      border-radius: 50%;
      text-align: center;
      line-height: 130px;
      background-color: rgba(0, 0, 0, 0.5);
      opacity: 0;
      transition: opacity 0.3s;
      .el-icon-delete {
        font-size: 24px;
        color: #fff;
        cursor: pointer;
      }
    }
  }
}
</style>